export default {
	messages: {
		de: {
			new: 'Neuer Eintrag',
		},
		en: {
			new: 'New Item',
		},
	},
};
